(() => {
  'use strict';

  const HANDLE = 'electrical-panel-custom-frame';
  if (!location.pathname.replace(/\/+$/, '').endsWith('/products/' + HANDLE)) return;
  const isArabic = document.documentElement.lang === 'ar';

  const syncOrderFields = (root) => {
    const selectedSize = root.querySelector('[data-epc-sizes] .epc-option-btn.is-selected');
    const selectedColor = root.querySelector('[data-epc-colors] .epc-swatch.is-selected');
    const selectedDirection = root.querySelector('.epc-direction-btn.is-selected');

    const variantId = selectedSize?.getAttribute('data-variant-id') || '';
    const sizeLabel = selectedSize ? (selectedSize.childNodes[0]?.textContent || '').trim() : '';
    const colorLabel = selectedColor?.getAttribute('data-color-label') || '';
    const direction = selectedDirection?.getAttribute('data-direction') || 'فتح يمين';

    const setField = (selector, value) => {
      const input = root.querySelector(selector);
      if (!input) return;
      input.value = value;
      input.defaultValue = value;
      input.setAttribute('value', value);
    };

    setField('[data-epc-variant-input]', variantId);
    setField('[data-epc-size-input]', sizeLabel);
    setField('[data-epc-color-input]', colorLabel);
    setField('[data-epc-direction-input]', direction);

    return { variantId, sizeLabel, colorLabel, direction };
  };

  const init = (root) => {
    if (root.dataset.portafotoOrderFix === 'true') return;
    root.dataset.portafotoOrderFix = 'true';

    const form = root.querySelector('[data-epc-form]');
    const error = root.querySelector('[data-epc-error]');
    if (!form) return;

    const syncSoon = () => {
      syncOrderFields(root);
      requestAnimationFrame(() => syncOrderFields(root));
      setTimeout(() => syncOrderFields(root), 80);
    };

    root.querySelectorAll(
      '[data-epc-sizes] .epc-option-btn, [data-epc-colors] .epc-swatch, .epc-direction-btn'
    ).forEach((button) => button.addEventListener('click', syncSoon));

    form.addEventListener('submit', (event) => {
      const values = syncOrderFields(root);
      if (!values.variantId || !values.colorLabel) {
        event.preventDefault();
        if (error) {
          error.hidden = false;
          error.textContent = isArabic ? 'اختار المقاس ولون الفريم الأول.' : 'Choose a size and frame colour first.';
        }
      }
    }, true);

    form.addEventListener('formdata', (event) => {
      const values = syncOrderFields(root);
      event.formData.set('id', values.variantId);
      event.formData.set(isArabic ? 'properties[المقاس]' : 'properties[Size]', values.sizeLabel);
      event.formData.set(isArabic ? 'properties[لون الفريم]' : 'properties[Frame colour]', values.colorLabel);
      event.formData.delete('properties[اتجاه الفتح]');
    });

    syncSoon();
  };

  const boot = () => document.querySelectorAll('[data-epc]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  setTimeout(boot, 600);
})();
